import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Header } from './components/header/header';
import { WhatsappButton } from '../../whatsapp/components/whatsapp-button';
import { Footer } from './components/footer/footer';
import { CookieConsentDialogComponent } from '../../cookie-consent/ui/cookie-consent-dialog.component';

@Component({
  selector: 'app-base-layout',
  imports: [
    RouterOutlet,
    Header,
    Footer,
    WhatsappButton,
    CookieConsentDialogComponent,
  ],
  template: `
    <app-header />

    <main>
      <router-outlet></router-outlet>
    </main>

    <app-footer />

    <app-whatsapp-button />

    <app-cookie-consent-dialog />
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BaseLayout {}
